import React from 'react';
import { Link } from 'react-router-dom';
import { platformUrls } from '../data/mockData';

const groups = [
  { title: 'Your blood testing', links: [
    ['customize', 'Find My Panel', '/order'], ['options', 'View All Panels', '/#shop'],
    ['collection', 'Collection Help', '/#how-it-works'], ['faq', 'Testing FAQs', '/#faq'],
  ] },
  { title: 'Results & support', links: [
    ['results', 'Help accessing your results', '/connected-care#results-support'],
    ['guide', 'Lab Marker Guide', '/results'], ['team', 'Contact the Care Team', 'tel:+12015353582'],
    ['yara', 'Ask Yara · Educational AI', '/yara'],
  ] },
  { title: 'Your ongoing care', links: [
    ['protocol', 'Start My Protocol', platformUrls.intake],
    ['portal', 'Optimization Portal', platformUrls.bodyApp],
    ['activation', 'Optimization Activation', platformUrls.intake],
    ['program', 'Explore Our Program', platformUrls.parent],
    ['community', 'Integrated Wellness Nexus', platformUrls.community],
  ] },
];

export default function Footer() {
  return (
    <footer id="contact" className="footer-light hbk-public-copy" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <p className="text-2xl font-heading font-bold" data-testid="footer-brand">HomeBloodKit</p>
            <p className="text-sm mt-3" data-testid="footer-description">By Integrated Wellness. At-home blood testing. Personalized beyond the lab.</p>
            <a href="tel:+12015353582" className="hbk-text-link mt-4" data-testid="footer-phone">(201) 535-3582</a>
            <p className="text-sm mt-4" data-testid="footer-address">331 Newman Springs Rd Building #3<br />Red Bank, NJ 07701</p>
          </div>
          {groups.map(({ title, links }) => <div key={title}>
            <h2 className="text-lg font-bold mb-3" data-testid={`footer-group-${links[0][0]}`}>{title}</h2>
            <ul>{links.map(([id, label, href]) => <li key={id}>{href.startsWith('/') ? <Link to={href} className="hbk-footer-link" data-testid={`footer-${id}`}>{label}</Link> : <a href={href} className="hbk-footer-link" {...(href.startsWith('https:') ? { target: '_blank', rel: 'noopener noreferrer' } : {})} data-testid={`footer-${id}`}>{label}</a>}</li>)}</ul>
          </div>)}
        </div>
        <div className="flex flex-wrap justify-between items-center gap-4 border-t border-[var(--line)] mt-9 pt-5 text-sm">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} Integrated Wellness</p>
          <div className="flex flex-wrap gap-5"><Link to="/privacy" className="hbk-footer-link" data-testid="footer-privacy">Privacy</Link><Link to="/terms" className="hbk-footer-link" data-testid="footer-terms">Terms</Link></div>
        </div>
      </div>
    </footer>
  );
}